import React, { useContext } from 'react';
import { Outlet } from 'react-router';
import { UserConst } from '@axiom/const';
import { PageContext } from '@axiom/ui';

import { AuthRoute } from '../routes/AuthRoute';

export const AccessLegalTalentPage = () => {
  const { setTitle } = useContext(PageContext);
  setTitle('AxiomLaw - Access Legal Talent');
  return (
    <AuthRoute
      name="AUTH_ROUTE"
      roles={[
        UserConst.Roles.ClientUser,
        UserConst.Roles.EnvoyAdmin,
        UserConst.Roles.EnvoyUser,
        UserConst.Roles.EnvoySales,
      ]}
    >
      <Outlet />
    </AuthRoute>
  );
};
